
document.addEventListener("DOMContentLoaded", function () {
  // 1. Inject CSS
  const style = document.createElement('style');
  style.textContent = `
    .custom-dropdown {
      position: relative;
      font-family: sans-serif;
    }

    .custom-dropdown-input {
      width: 100%;
      padding: 6px;
      color: #0d0d0d;
      font-size: 18px;
      border: none;
      box-sizing: border-box;
      cursor: pointer;
      box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.20);
      outline: none;
    }

    .custom-dropdown-input:focus {
      border: none;
      outline: none;
    }
    .custom-dropdown-options::-webkit-scrollbar {
      width: 6px; /* or less, like 4px */
    }

.custom-dropdown-options::-webkit-scrollbar-track {
  background: #f1f1f1; 
}

.custom-dropdown-options::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 3px;
}

.custom-dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* For Firefox */
.custom-dropdown-options {
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}


    .custom-dropdown-options {
      position: absolute;
      width: 100%;
      max-height: 200px;
      overflow-y: auto;
      background-color: #fff;
      border: 1px solid #ccc;
      border-top: none;
      border-radius: 0 0 6px 6px;
      list-style: none;
      margin: 0;
      padding: 0;
      z-index: 999;
      display: none;
      box-shadow: 4px 4px 5px rgba(0, 0, 0, 0.25);
    }

.custom-dropdown-options li {
  padding: 10px 12px;
  cursor: pointer;
  font-size: 18px;
  line-height: 1.3;
  display: flex;
  justify-content: space-between; /* space between name and price */
  align-items: flex-start; /* align top, so price and name lines up nicely */
  gap: 10px; /* space between name and price */
}

.custom-dropdown-options li .option-name {
  display: block;
  margin-bottom: 4px;
  white-space: normal;
  flex: 1; /* take remaining space */
}

.custom-dropdown-options li .option-price {
  display: inline-block;
  white-space: nowrap;
  font-weight: bold; /* bold price */
  text-align: right; /* right align price */
  min-width: 100px; /* optional: reserve space for price */
  flex-shrink: 0;
}



    .custom-dropdown-options li:hover {
      background-color: #f0f0f0;
    }
  `;
  document.head.appendChild(style);

  // 2. Append dropdown to desired container
  const container = document.getElementById("your-container-id"); // Replace with your actual container ID
  if (!container) return;

  const dropdown = document.createElement("div");
  dropdown.className = "custom-dropdown";
  dropdown.innerHTML = `
    <input type="text" class="custom-dropdown-input" placeholder="Brand..." readonly />
    <ul class="custom-dropdown-options"></ul>
  `;
  container.appendChild(dropdown);

  // 3. Dropdown logic
  const input = dropdown.querySelector(".custom-dropdown-input");
  const optionsList = dropdown.querySelector(".custom-dropdown-options");

  const options = ["Thermaltake", "TAG Gamerz", "Phanteks", "NZXT", "Montech"];
  let isOpen = false;

  function populateDropdown(filteredOptions = options) {
    optionsList.innerHTML = "";

    filteredOptions.forEach(option => {
      const li = document.createElement("li");
      li.textContent = option;
      li.addEventListener("click", () => {
        input.value = option;
        optionsList.style.display = "none";
        isOpen = false;
        input.readOnly = true;
      });
      optionsList.appendChild(li);
    });
  }

  input.addEventListener("click", () => {
    isOpen = !isOpen;
    optionsList.style.display = isOpen ? "block" : "none";
    input.readOnly = !isOpen;
    if (isOpen) {
      input.focus();
      input.select(); // Allow typing immediately
    }
  });

  input.addEventListener("input", (e) => {
    const search = e.target.value.toLowerCase();
    const filtered = options.filter(option => option.toLowerCase().includes(search));
    populateDropdown(filtered);
  });

  document.addEventListener("click", (e) => {
    if (!dropdown.contains(e.target)) {
      isOpen = false;
      optionsList.style.display = "none";
      input.readOnly = true;
    }
  });

  // Initial render
  populateDropdown();
});